"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_form-block-description.scss");

function getDescription(description) {
  return "string" == typeof description ? _react["default"].createElement("p", null, description) : description.map(function (descString) {
    return descString ? _react["default"].createElement("p", {
      key: descString
    }, descString) : null;
  });
}

function FormBlockDescription(_ref) {
  var name = _ref.name,
      description = _ref.description,
      buttonText = _ref.buttonText,
      isPrimaryButton = _ref.isPrimaryButton,
      onClickButton = _ref.onClickButton,
      hideButton = _ref.hideButton,
      highlightedName = _ref.highlightedName,
      additionalContent = _ref.additionalContent,
      upperCaseName = name.toUpperCase();
  return [_react["default"].createElement("div", {
    key: "form-block-desc",
    className: "form-block-description"
  }, _react["default"].createElement("p", null, highlightedName ? _react["default"].createElement("strong", null, upperCaseName) : upperCaseName), getDescription(description)), hideButton ? null : _react["default"].createElement(_uiKit.Button, {
    key: "form-block-btn",
    small: !0,
    type: isPrimaryButton ? void 0 : "INVERTED",
    onClick: onClickButton
  }, buttonText), additionalContent];
}

FormBlockDescription.defaultProps = {
  additionalContent: null
};

var _default = (0, _react.memo)(FormBlockDescription);

exports["default"] = _default;